import * as navigation from 'Navigation';

export default class BoxTabState extends navigation.TabState {
  defaults(): navigation.TabStateDefaults {
    return {
      ...super.defaults(),
      title: 'Box',
      closeable: false,
      preferenceKey: 'box',
    };
  }
}
